/*
 * @Author: wangminghua
 * @Date: 2022-04-10 12:25:42
 * @Last Modified by: wangminghua
 * @Last Modified time: 2022-04-15 17:22:41
 */
<template>
  <div class="my-space" :class="[direction, size]">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    /**
     * 排列的方向
     * 可选值：vertical/horizontal
     */
    direction: {
      type: String,
      default: 'horizontal'
    },
    /**
     * 间隔大小
     * 可选值：zero/small/default/large 对应：0px 4px 8px 12px
     */
    size: {
      type: String,
      default: 'default'
    }
  },
  data () {
    return {}
  },
  mounted () {}
}
</script>

<style lang="scss" scoped>
.my-space {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  &.horizontal {
    &.zero {
      > * {
        margin-left: 0px;
      }
    }
    &.small {
      > * {
        margin-left: 4px;
      }
    }
    &.default {
      > * {
        margin-left: 8px;
      }
    }
    &.large {
      > * {
        margin-left: 12px;
      }
    }
    > *:first-child {
      margin-left: 0px;
    }
  }

  &.vertical {
    flex-direction: column;
    justify-items: center;
    &.zero {
      > * {
        margin-top: 0px;
      }
    }
    &.small {
      > * {
        margin-top: 4px;
      }
    }
    &.default {
      > * {
        margin-top: 8px;
      }
    }
    &.large {
      > * {
        margin-top: 12px;
      }
    }
    > *:first-child {
      margin-top: 0px;
    }
  }
}
</style>
